import type { Tournament } from "@/types";

// Torneio em destaque: o ativo mais recente; senão o próximo a começar
// (versão simplificada do selectFeaturedTournament original). Compartilhado
// entre Home (card principal) e Perfil (texto de saldos).
export function selectFeatured(tournaments: Tournament[]): Tournament | null {
  const active = tournaments.filter((t) => t.status === "active");
  if (active.length > 0) return active[0]!;
  const upcoming = tournaments
    .filter((t) => t.status === "upcoming")
    .sort(
      (a, b) =>
        new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
    );
  return upcoming[0] ?? null;
}
